import { inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT } from '@core/config/app-environment';
import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';
import { Database, getDatabase } from 'firebase/database';

/**
 * Owns the Firebase app (modular SDK, no @angular/fire). Auth and Realtime Database instances
 * are created lazily so pages that do not need them (e.g. the customer kiosk does not use Auth)
 * do not initialize them.
 */
@Injectable({ providedIn: 'root' })
export class FirebaseService {
  private readonly env = inject(APP_ENVIRONMENT);
  private _app?: FirebaseApp;
  private _auth?: Auth;
  private _db?: Database;

  get app(): FirebaseApp {
    if (!this._app) {
      this._app = getApps().length > 0 ? getApp() : initializeApp(this.env.firebaseKeys);
    }
    return this._app;
  }

  get auth(): Auth {
    if (!this._auth) {
      this._auth = getAuth(this.app);
    }
    return this._auth;
  }

  /** Default Realtime Database of the app (`firebaseKeys.databaseURL`), like AngularFireDatabase. */
  get db(): Database {
    if (!this._db) {
      this._db = getDatabase(this.app);
    }
    return this._db;
  }
}
